const API_URL = import.meta.env.VITE_API_URL || '';

function getCookie(name) {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp('(^|;)\\s*' + name + '=([^;]*)'));
  return match ? decodeURIComponent(match[2]) : null;
}

function getAuthHeaders() {
  const token = localStorage.getItem('auth_token');
  const tenantId = localStorage.getItem('challenges_active_tenant') || localStorage.getItem('tenant_id') || getCookie('challenges_active_tenant');
  const devBypass = localStorage.getItem('challenges_dev_bypass') || getCookie('challenges_dev_bypass');
  const headers = {};
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  } else if (devBypass) {
    // PoC dev bypass — remove when Firebase Auth is integrated
    headers['X-Dev-Bypass'] = devBypass;
  }
  if (tenantId) headers['X-Tenant-ID'] = tenantId;
  return headers;
}

async function request(path, options = {}) {
  const url = `${API_URL}${path}`;
  const headers = new Headers({
    'Content-Type': 'application/json',
    ...getAuthHeaders(),
  });
  // Allow callers to override auth/tenant headers explicitly
  Object.entries(options.headers || {}).forEach(([key, value]) => {
    headers.set(key, value);
  });

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (!response.ok) {
    const error = new Error(`HTTP ${response.status}: ${response.statusText}`);
    error.status = response.status;
    try {
      error.body = await response.json();
    } catch {}
    throw error;
  }

  return response.json();
}

export function get(path) {
  return request(path, { method: 'GET' });
}

export function post(path, body, options = {}) {
  return request(path, { method: 'POST', body: JSON.stringify(body), ...options });
}

export function put(path, body, options = {}) {
  return request(path, { method: 'PUT', body: JSON.stringify(body), ...options });
}

export function del(path, options = {}) {
  return request(path, { method: 'DELETE', ...options });
}

export function getBlob(path) {
  const url = `${API_URL}${path}`;
  return fetch(url, { method: 'GET', headers: getAuthHeaders() }).then(async (response) => {
    if (!response.ok) {
      const error = new Error(`HTTP ${response.status}: ${response.statusText}`);
      error.status = response.status;
      try {
        error.body = await response.json();
      } catch {}
      throw error;
    }
    return response.blob();
  });
}

export function upload(path, formData) {
  const url = `${API_URL}${path}`;
  return fetch(url, {
    method: 'POST',
    body: formData,
    headers: getAuthHeaders(),
  }).then(async (response) => {
    if (!response.ok) {
      const error = new Error(`HTTP ${response.status}: ${response.statusText}`);
      error.status = response.status;
      try {
        error.body = await response.json();
      } catch {}
      throw error;
    }
    return response.json();
  });
}

export default { get, post, put, del, upload, getBlob };
